import { processUploadDocumentJobSagas } from './processUploadDocumentJob.sagas';
import { uploadDocumentsSagas } from './uploadDocument.sagas';

export const uploadDocumentJobsSagas = [processUploadDocumentJobSagas, uploadDocumentsSagas];
